import React from 'react'
import Title from '../components/dashContent/Title'
import { Outlet } from 'react-router-dom';

const Events = () => {
  return (
    <div className='m-1'>
      <Title text="Eventos" />
      <Outlet>
        
      </Outlet>
    </div>
  )
}

export default Events